export default {
  music: "null",
  slide_name: "ProSlide",
  stdSpeed: {
    value_description: "normal",
    values: [{ key: "Taktgeschwindigkeit", value: 4 }],
  },
  stdProgram: {
    value_description: "alle blinken",
    values: [{ key: "Programmablauf", value: 1 }],
  },
  stdStrobe: {
    value_description: "Aquastrobe",
    values: [{ key: "Aquastrobe", value: 1 }],
  },
  stdColor: {
    colorKey: "orange",
    colorName: "orange",
    values: [
      { key: "Farbe1", value: 1 },
      { key: "Farbe2", value: 1 },
      { key: "Farbe3", value: 1 },
      { key: "Farbe4", value: 1 },
      { key: "Farbe5", value: 1 },
      { key: "Farbe6", value: 1 },
      { key: "Farbe7", value: 1 },
      { key: "Farbe8", value: 1 },
    ],
  },
  effects: [
    {
      id: "Twister 1",
      effect_name: "Twister",
      position: 0.1,
      params: [
        {
          param_name: "Programm",
          param_id: "Programmablauf",
          values: [
            {
              value_description: "alle blinken",
              values: [
                {
                  key: "Programmablauf",
                  value: 1,
                },
              ],
            },
            {
              value_description: "eine Schlange rotiert",
              values: [
                {
                  key: "Programmablauf",
                  value: 2,
                },
              ],
            },
            {
              value_description: "3 Bänder",
              values: [
                {
                  key: "Programmablauf",
                  value: 12,
                },
              ],
            },
            {
              value_description: "hintereinander Aufleuchten",
              values: [
                {
                  key: "Programmablauf",
                  value: 13,
                },
              ],
            },
            {
              value_description: "dunkle Schlange",
              values: [
                {
                  key: "Programmablauf",
                  value: 15,
                },
              ],
            },
          ],
        },
        {
          param_name: "Effektgeschwindigkeit",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16,
                },
              ],
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8,
                },
              ],
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4,
                },
              ],
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2,
                },
              ],
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "Runninglight RGB",
      effect_name: "Runninglight",
      position: 0.2,
      params: [
        {
          param_name: "Programm",
          param_id: "Programmablauf",
          values: [
            {
              value_description: "alle blinken",
              values: [
                {
                  key: "Programmablauf",
                  value: 1,
                },
              ],
            },
            {
              value_description: "eine Schlange rotiert",
              values: [
                {
                  key: "Programmablauf",
                  value: 2,
                },
              ],
            },
            {
              value_description: "3 Bänder",
              values: [
                {
                  key: "Programmablauf",
                  value: 12,
                },
              ],
            },
            {
              value_description: "hintereinander Aufleuchten",
              values: [
                {
                  key: "Programmablauf",
                  value: 13,
                },
              ],
            },
            {
              value_description: "dunkle Schlange",
              values: [
                {
                  key: "Programmablauf",
                  value: 15,
                },
              ],
            },
          ],
        },
        {
          param_name: "Effektgeschwindigkeit",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16,
                },
              ],
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8,
                },
              ],
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4,
                },
              ],
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2,
                },
              ],
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1,
                },
              ],
            },
          ],
        },
        {
          param_name: "Farbe",
          param_id: "Farbe Ring",
          values: [
            {
              value_description: "rot",
              values: [
                {
                  key: "Farbe1",
                  value: 2,
                },
                {
                  key: "Farbe2",
                  value: 2,
                },
                {
                  key: "Farbe3",
                  value: 2,
                },
                {
                  key: "Farbe4",
                  value: 2,
                },
                {
                  key: "Farbe5",
                  value: 2,
                },
                {
                  key: "Farbe6",
                  value: 2,
                },
                {
                  key: "Farbe7",
                  value: 2,
                },
                {
                  key: "Farbe8",
                  value: 2,
                },
              ],
            },
            {
              value_description: "grün",
              values: [
                {
                  key: "Farbe1",
                  value: 3,
                },
                {
                  key: "Farbe2",
                  value: 3,
                },
                {
                  key: "Farbe3",
                  value: 3,
                },
                {
                  key: "Farbe4",
                  value: 3,
                },
                {
                  key: "Farbe5",
                  value: 3,
                },
                {
                  key: "Farbe6",
                  value: 3,
                },
                {
                  key: "Farbe7",
                  value: 3,
                },
                {
                  key: "Farbe8",
                  value: 3,
                },
              ],
            },
            {
              value_description: "blau",
              values: [
                {
                  key: "Farbe1",
                  value: 4,
                },
                {
                  key: "Farbe2",
                  value: 4,
                },
                {
                  key: "Farbe3",
                  value: 4,
                },
                {
                  key: "Farbe4",
                  value: 4,
                },
                {
                  key: "Farbe5",
                  value: 4,
                },
                {
                  key: "Farbe6",
                  value: 4,
                },
                {
                  key: "Farbe7",
                  value: 4,
                },
                {
                  key: "Farbe8",
                  value: 4,
                },
              ],
            },
            {
              value_description: "weiß",
              values: [
                {
                  key: "Farbe1",
                  value: 5,
                },
                {
                  key: "Farbe2",
                  value: 5,
                },
                {
                  key: "Farbe3",
                  value: 5,
                },
                {
                  key: "Farbe4",
                  value: 5,
                },
                {
                  key: "Farbe5",
                  value: 5,
                },
                {
                  key: "Farbe6",
                  value: 5,
                },
                {
                  key: "Farbe7",
                  value: 5,
                },
                {
                  key: "Farbe8",
                  value: 5,
                },
              ],
            },
            {
              value_description: "gelb",
              values: [
                {
                  key: "Farbe1",
                  value: 6,
                },
                {
                  key: "Farbe2",
                  value: 6,
                },
                {
                  key: "Farbe3",
                  value: 6,
                },
                {
                  key: "Farbe4",
                  value: 6,
                },
                {
                  key: "Farbe5",
                  value: 6,
                },
                {
                  key: "Farbe6",
                  value: 6,
                },
                {
                  key: "Farbe7",
                  value: 6,
                },
                {
                  key: "Farbe8",
                  value: 6,
                },
              ],
            },
            {
              value_description: "magenta",
              values: [
                {
                  key: "Farbe1",
                  value: 7,
                },
                {
                  key: "Farbe2",
                  value: 7,
                },
                {
                  key: "Farbe3",
                  value: 7,
                },
                {
                  key: "Farbe4",
                  value: 7,
                },
                {
                  key: "Farbe5",
                  value: 7,
                },
                {
                  key: "Farbe6",
                  value: 7,
                },
                {
                  key: "Farbe7",
                  value: 7,
                },
                {
                  key: "Farbe8",
                  value: 7,
                },
              ],
            },
            {
              value_description: "cyan",
              values: [
                {
                  key: "Farbe1",
                  value: 8,
                },
                {
                  key: "Farbe2",
                  value: 8,
                },
                {
                  key: "Farbe3",
                  value: 8,
                },
                {
                  key: "Farbe4",
                  value: 8,
                },
                {
                  key: "Farbe5",
                  value: 8,
                },
                {
                  key: "Farbe6",
                  value: 8,
                },
                {
                  key: "Farbe7",
                  value: 8,
                },
                {
                  key: "Farbe8",
                  value: 8,
                },
              ],
            },
            {
              value_description: "cyan-magenta-gelb",
              values: [
                {
                  key: "Farbe1",
                  value: 8,
                },
                {
                  key: "Farbe2",
                  value: 7,
                },
                {
                  key: "Farbe3",
                  value: 6,
                },
                {
                  key: "Farbe4",
                  value: 1,
                },
                {
                  key: "Farbe5",
                  value: 8,
                },
                {
                  key: "Farbe6",
                  value: 7,
                },
                {
                  key: "Farbe7",
                  value: 6,
                },
                {
                  key: "Farbe8",
                  value: 1,
                },
              ],
            },
            {
              value_description: "blau-weiß",
              values: [
                {
                  key: "Farbe1",
                  value: 4,
                },
                {
                  key: "Farbe2",
                  value: 5,
                },
                {
                  key: "Farbe3",
                  value: 4,
                },
                {
                  key: "Farbe4",
                  value: 5,
                },
                {
                  key: "Farbe5",
                  value: 4,
                },
                {
                  key: "Farbe6",
                  value: 5,
                },
                {
                  key: "Farbe7",
                  value: 4,
                },
                {
                  key: "Farbe8",
                  value: 5,
                },
              ],
            },
            {
              value_description: "Regenbogen",
              values: [
                {
                  key: "Farbe1",
                  value: 1,
                },
                {
                  key: "Farbe2",
                  value: 2,
                },
                {
                  key: "Farbe3",
                  value: 6,
                },
                {
                  key: "Farbe4",
                  value: 3,
                },
                {
                  key: "Farbe5",
                  value: 8,
                },
                {
                  key: "Farbe6",
                  value: 4,
                },
                {
                  key: "Farbe7",
                  value: 7,
                },
                {
                  key: "Farbe8",
                  value: 1,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "Aquastrobe",
      effect_name: "Stroboskop",
      bundledEffects: true,
      position: 0.3,
      params: [
        {
          param_name: "Effektgeschwindigkeit 1",
          subIndex: 0,
          sub_id: "Aquastrobe 1-9",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16,
                },
              ],
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8,
                },
              ],
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4,
                },
              ],
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2,
                },
              ],
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1,
                },
              ],
            },
          ],
        },
        {
          param_name: "Effektgeschwindigkeit 2",
          subIndex: 1,
          sub_id: "Aquastrobe 10-16",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16,
                },
              ],
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8,
                },
              ],
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4,
                },
              ],
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2,
                },
              ],
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1,
                },
              ],
            },
          ],
        },
        {
          param_name: "Effektgeschwindigkeit 3",
          subIndex: 2,
          sub_id: "Aquastrobe 17-23",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16,
                },
              ],
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8,
                },
              ],
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4,
                },
              ],
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2,
                },
              ],
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1,
                },
              ],
            },
          ],
        },
        {
          param_name: "Effektgeschwindigkeit 4",
          param_id: "Taktgeschwindigkeit",
          subIndex: 3,
          sub_id: "Schwarzlicht",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16,
                },
              ],
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8,
                },
              ],
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4,
                },
              ],
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2,
                },
              ],
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "Twister 2",
      effect_name: "Twister",
      position: 0.8,
      params: [
        {
          param_name: "Programm",
          param_id: "Programmablauf",
          values: [
            {
              value_description: "alle blinken",
              values: [
                {
                  key: "Programmablauf",
                  value: 1,
                },
              ],
            },
            {
              value_description: "eine Schlange rotiert",
              values: [
                {
                  key: "Programmablauf",
                  value: 2,
                },
              ],
            },
            {
              value_description: "3 Bänder",
              values: [
                {
                  key: "Programmablauf",
                  value: 12,
                },
              ],
            },
            {
              value_description: "hintereinander Aufleuchten",
              values: [
                {
                  key: "Programmablauf",
                  value: 13,
                },
              ],
            },
            {
              value_description: "dunkle Schlange",
              values: [
                {
                  key: "Programmablauf",
                  value: 15,
                },
              ],
            },
          ],
        },
        {
          param_name: "Effektgeschwindigkeit",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16,
                },
              ],
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8,
                },
              ],
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4,
                },
              ],
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2,
                },
              ],
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "Aquastrobe 24-29",
      effect_name: "Stroboskop",
      params: [
        {
          param_name: "Effektgeschwindigkeit",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16,
                },
              ],
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8,
                },
              ],
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4,
                },
              ],
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2,
                },
              ],
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
